import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { ensure } from 'components/sharpr/ensure/ensure';

export function TrustedAuthListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.TrustedAuthListing', {
		url: '/admin/trusted_auth',
		controllerAs: 'vm',
		controller: TrustedAuthListingCtrl,
		templateUrl: '/ng/hub/TrustedAuth/Listing/TrustedAuthListingCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'Trusted Auth',
		},
	});
}

export class TrustedAuthListingCtrl {
	constructor($filter, Api, modal, $state) {
		'ngInject';
		// save injections
		this.shDateFormat = $filter('shDate');
		this.Api = Api;
		this.modal = modal;
		this.$state = $state;
		// bind functions
		this.rename = this.rename.bind(this);
		this.delete = this.delete.bind(this);
		this.format = this.format.bind(this);
		// define table details
		this.columns = [
			{ field: 'name', label: 'Name', sortable: false },
			{ field: 'username', label: 'Username', sortable: false },
			{ field: 'password', label: 'Password', sortable: false },
			{ field: 'created_at', label: 'Created', sortable: false },
		];
		this.actions = [
			{ label: null, icon: 'pencil', callback: this.rename },
			{ label: null, icon: 'delete2', callback: this.delete },
		];
		this.filters = {
			refresh: false,
		};
	}

	format(result) {
		ensure.array(result.data).forEach(auth => {
			auth.created_at = this.shDateFormat(auth.created_at, 'long');
			auth.deleted_at = this.shDateFormat(auth.deleted_at, 'long');
		});
		return result;
	}

	add() {
		this.modal
			.state('hub.loggedin.TrustedAuthAdd', {
				heading: 'Add Trusted Auth',
				height: 550,
				width: 750,
			})
			.then(
				() => {
					this.$state.reload();
				},
				() => {}
			);
	}

	rename(auth) {
		this.modal
			.state('hub.loggedin.TrustedAuthEdit', {
				heading: 'Edit Trusted Auth',
				height: 550,
				width: 750,
				params: { id: auth.id },
			})
			.then(
				() => {
					this.$state.reload();
				},
				() => {}
			);
	}

	delete(auth) {
		this.modal.confirm({ text: `Are you sure you want to delete ${_.escape(auth.name)}?` }).then(
			name => {
				this.Api.delete(`/auth/trusted/${auth.id}`).then(() => {
					this.$state.reload();
				});
			},
			() => {}
		);
	}
}
